export enum VenueAvailabilityStatus {
  IPAD_NOT_ALIVE = 'ipadNotAlive',
  OFFLINE = 'offline',
  CLOSED = 'closed',
  AVAILABLE = 'available',
  INACTIVE = 'inactive',
}
